import { render, staticRenderFns } from "./InteriorBottom.vue?vue&type=template&id=4ebaa766&scoped=true&"
import script from "./InteriorBottom.vue?vue&type=script&lang=js&"
export * from "./InteriorBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebaa766",
  null
  
)

export default component.exports